import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/app.css';

// Wait for DOM and drupalSettings to be available
const init = () => {
  const container = document.getElementById('project-map-root');
  if (!container) {
    console.error('Project map root element not found');
    return;
  }

  // Get settings from Drupal
  const settings = window.drupalSettings?.urbanizeProjectMap || {};

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App
        apiUrl={settings.apiUrl || container.dataset.apiUrl}
        mapboxToken={settings.mapboxToken}
        mapboxStyle={settings.mapboxStyle}
        cityName={settings.cityName || 'Urbanize'}
      />
    </React.StrictMode>
  );
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}


